// Portalled surfaces render at the end of <body>, so they compete with the app's
// own stacking contexts instead of sitting above them by default. Two layers, in
// order, because a floating popup can be opened from inside a dialog:
//
//   app chrome (AI chat panel, card hover overlays) ... z-50
//   DIALOG_LAYER   dialog backdrop + popup ........... z-[60]
//   FLOATING_LAYER combobox / menu / popover popups .. z-[70]
export const DIALOG_LAYER = 'z-[60]';
export const FLOATING_LAYER = 'z-[70]';
